import React, { createContext, useContext, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import execute from "hooks/execute";
import { protectedResources } from '../config/msalConfig';
import { useEffect } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const { instance } = useMsal();
  let activeAccount;

  if (instance) {
      activeAccount = instance.getActiveAccount();
  }



  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    const verifyUser = async (email) => {
      try {
        if(userDetails.email === activeAccount.idTokenClaims.email) {
          return;
        }
        console.log('Verifying user:', email);
        const response = await execute("GET", `${protectedResources.api.baseEndPoint}/adminUsers/${email}`);
        if (!response.data?.isActive) {
          // Display user-friendly error message using Ant Design Modal
          Modal.error({
            title: 'Authentication Error',
            icon: <ExclamationCircleOutlined />,
            content: response.message || 'You are not allowed to log in.',
            centered: true,
            maskClosable: false,
            okText: 'OK',
            onOk: () => {
              instance.logoutRedirect();
            }
          });
        }else{
          setUserDetails({ ...activeAccount.idTokenClaims, ...response.data });
        }
      } catch (error) {
        console.error('Error verifying user:', error);

        // Check if this is a 404 error (user not found)
        if (error.response?.status === 404 || error.status === 404) {
          Modal.error({
            title: 'User Not Found',
            icon: <ExclamationCircleOutlined />,
            content: error.response.message || error.message || 'Your account was not found in the admin console. You may be trying to access the wrong application (customer app vs. admin console).',
            centered: true,
            maskClosable: false,
            okText: 'OK',
            onOk: () => {
              instance.logoutRedirect();
            }
          });
        } else {
          // Generic error for other cases
          Modal.error({
            title: 'Authentication Error',
            icon: <ExclamationCircleOutlined />,
            content: 'An error occurred while verifying your account. Please try again.',
            centered: true,
            maskClosable: false,
            okText: 'OK',
            onOk: () => {
              instance.logoutRedirect();
            }
          });
        }
      }
    };
    if (activeAccount?.idTokenClaims?.email) {
      console.log('Active account:', activeAccount);
      verifyUser(activeAccount.idTokenClaims.email);
    }
  }, [activeAccount, instance, userDetails.email]);

  return (
    <UserContext.Provider value={{ userDetails }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
